import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image";
import Button, { ButtonA } from "components/Elements/Button/Button";
import useMediaQueries from "hooks/useMediaQueries";
import useInviewSettingsDelay from "../../helpers/useAnimateInview";
import CustomAnimationContol from "./CustomAnimationContol";
import useGetStartedLoginCallback from "../../helpers/useGetStartedLoginCallback";
import { useInView } from "react-intersection-observer";
import { useContent } from "contexts/contentContext/contentContext";
import config from "config";

import generalStyles from "../../styles.module.scss";
import styles from "./styles.module.scss";

const FourthSection = () => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { mobileCondition } = useMediaQueries();

  const { inviewSettings, getFullClassName } = useInviewSettingsDelay();

  const [firstRowRef, firstRowInView] = useInView(inviewSettings);
  const [secondRowRef, secondRowInView] = useInView(inviewSettings);
  const [thirdRowRef, thirdRowInView] = useInView(inviewSettings);
  const [fourthRowRef, fourthRowInView] = useInView(inviewSettings);

  const handleClick = useGetStartedLoginCallback();

  return (
    <>
      <section className={styles.section}>
        <div className={styles.rowSection} ref={firstRowRef}>
          {!mobileCondition && (
            <div
              className={getFullClassName(
                styles.imageSection,
                "start",
                firstRowInView
              )}
            >
              <Image name="picker/picker-receive" ext="png" />
            </div>
          )}
          <div
            className={getFullClassName(
              styles.textSection,
              "end",
              firstRowInView
            )}
          >
            <Icon name="folders-light" gray />
            <h3 className={generalStyles.titleDark}>
              {getTextByKey("picker-section-4-title-first")}
            </h3>
            <p className={generalStyles.textDark}>
              {getHtmlByKey("picker-section-4-text-first")}
            </p>
          </div>
          {mobileCondition && (
            <div className={styles.imageSection}>
              <Image name="picker/picker-receive-mob" ext="png" />
            </div>
          )}
        </div>
        <div className={styles.rowSection} ref={secondRowRef}>
          <div
            className={getFullClassName(
              styles.textSection,
              "start",
              secondRowInView
            )}
          >
            <Icon name="google-drive" ext="png" />
            <h3 className={generalStyles.titleDark}>
              {getTextByKey("picker-section-4-title-second")}
            </h3>
            {mobileCondition && (
              <div className={styles.imageSection}>
                <video controls={false} autoPlay muted loop>
                  <source
                    src={`${config.api.resource}/assets/images/picker/gd_link_short.mp4`}
                    type="video/mp4"
                  />
                </video>
              </div>
            )}
            <p className={generalStyles.textDark}>
              {getHtmlByKey("picker-section-4-text-second")}
            </p>
            <Button title={getTextByKey("get-started")} onClick={handleClick} />
          </div>
          {!mobileCondition && (
            <div
              className={getFullClassName(
                styles.imageSection,
                "end",
                secondRowInView
              )}
            >
              <video controls={false} autoPlay muted loop>
                <source
                  src={`${config.api.resource}/assets/images/picker/gd_link_short.mp4`}
                  type="video/mp4"
                />
              </video>
            </div>
          )}
        </div>
        <div className={styles.bgFlareBlue}></div>
        <div className={styles.bgFlareViolet}></div>
        <Image className={styles.cloudImage} name="cloud" ext="png" />
      </section>
      <section className={styles.section}>
        <div className={styles.rowSection} ref={thirdRowRef}>
          {!mobileCondition && (
            <div
              className={getFullClassName(
                styles.imageSection,
                "start",
                thirdRowInView
              )}
            >
              <CustomAnimationContol />
            </div>
          )}
          <div
            className={getFullClassName(
              styles.textSection,
              "end",
              thirdRowInView
            )}
          >
            <Icon name="control" gray />
            <h3 className={generalStyles.titleDark}>
              {getTextByKey("picker-section-4-title-third")}
            </h3>
            <p className={generalStyles.textDark}>
              {getHtmlByKey("picker-section-4-text-third")}
            </p>
          </div>
          {mobileCondition && <CustomAnimationContol />}
        </div>
      </section>
      <section className={styles.sectionDark}>
        <div
          className={styles.rowSectionDark + " " + styles.tabletUnique}
          ref={fourthRowRef}
        >
          <div
            className={getFullClassName(
              styles.textSection,
              "start",
              fourthRowInView
            )}
          >
            <Image name="picker/picker-jumbomail-logos" ext="png" />
            <h3 className={generalStyles.titleLight}>
              {getTextByKey("picker-section-4-title-fourth")}
            </h3>
            <p className={generalStyles.textLight}>
              {getHtmlByKey("picker-section-4-text-fourth-main")}
              <div className={styles.customTextContainer}>
                <Icon name="pricing" gray />
                <div>
                  <div className={styles.title}>
                    {getHtmlByKey(
                      "picker-section-4-text-fourth-additional-title"
                    )}
                  </div>
                  {!mobileCondition && (
                    <div>
                      {getHtmlByKey(
                        "picker-section-4-text-fourth-additional-text"
                      )}
                    </div>
                  )}
                </div>
              </div>
              {mobileCondition && (
                <div>
                  {getHtmlByKey("picker-section-4-text-fourth-additional-text")}
                </div>
              )}
            </p>
            <ButtonA
              title={getTextByKey("see-plans")}
              page="plans"
              buttonClass={styles.seePlansButton}
            />
          </div>
          <div
            className={getFullClassName(
              styles.imageSection +
                (mobileCondition ? " " + styles.noMargin : ""),
              "end",
              fourthRowInView
            )}
          >
            <Image
              name={mobileCondition ? "picker/jm-img-mob" : "picker/jm-img"}
              ext="png"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default FourthSection;
